import { isTokenExpired, clearExpiredToken } from "../utils";

function parseData(data) {
  const formData = new FormData();
  for (let [key, value] of Object.entries(data)) {
    formData.append(key, value);
  }
  return formData;
}

function request(url, data = false, method = "GET", type = "FORM_DATA") {
  return new Promise(async (resolve, reject) => {
    try {
      // Eğer data bir token ise ve expire olmuşsa, temizle ve hata döndür
      if (data && typeof data === "string" && isTokenExpired(data)) {
        clearExpiredToken();
        // Token expired hatası döndür
        reject({
          sonuc: false,
          sonucAciklama:
            "Oturumunuzun suresi dolmustur. Lutfen tekrar giris yapiniz.",
          sonucKodu: "TOKEN_EXPIRED",
        });
        return;
      }

      // Eğer data bir obje ise ve token property'si varsa, onu da kontrol et
      if (
        data &&
        typeof data === "object" &&
        data.token &&
        isTokenExpired(data.token)
      ) {
        clearExpiredToken();
        reject({
          sonuc: false,
          sonucAciklama:
            "Oturumunuzun suresi dolmustur. Lutfen tekrar giris yapiniz.",
          sonucKodu: "TOKEN_EXPIRED",
        });
        return;
      }

      const options = {
        method,
        headers: {
          "Content-Type": "application/json",
        },
      };

      if (data) {
        options.headers.Authorization = data;
      }

      if (data && method === "POST") {
        if (data.token != null) {
          options.headers.Authorization = data.token;

          options.body =
            type === "JSON" ? JSON.stringify(data) : parseData(data);
        } else {
          options.headers.Authorization = data;
          options.body =
            type === "JSON" ? JSON.stringify(data) : parseData(data);
        }
      }

      const response = await fetch(url, options);
      const result = await response.json();

      // Backend'den token expired hatası gelirse
      if (
        !response.ok ||
        (result &&
          result.sonucAciklama &&
          (result.sonucAciklama.includes("Oturumunuzun suresi dolmustur") ||
            result.sonucAciklama.includes("Oturum hatası") ||
            result.sonucAciklama.includes("token") ||
            result.sonucKodu === "TOKEN_EXPIRED"))
      ) {
        clearExpiredToken();
        // Sayfayı yeniden yükle veya login sayfasına yönlendir
        if (typeof window !== "undefined") {
          setTimeout(() => {
            window.location.href = "/login";
          }, 1000);
        }
      }

      if (response.ok) {
        resolve(result);
      } else {
        reject(result);
      }
    } catch (error) {
      return error;
    }
  });
}

export const post = (url, data) => request(url, data, "POST");
export const postJSON = (url, data) => request(url, data, "POST", "JSON");
export const get = (url, data) => request(url, data);
